import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import BrandFocus from '@/pages/home/components/BrandFocus';
import EditorPicks from '@/pages/home/components/EditorPicks';
import TopicSpotlight from '@/pages/home/components/TopicSpotlight';
import { siteConfig } from '@/mocks/site';

const features = [
  { icon: 'ri-book-open-line', title: '详实剧情介绍', desc: '逐部梳理影视作品的故事脉络与关键情节' },
  { icon: 'ri-newspaper-line', title: '深度影评资讯', desc: '编辑视角解读作品，持续更新行业动态' },
  { icon: 'ri-user-star-line', title: '演员资料库', desc: '演员简介与代表作一览，快速了解你所关注的演员' },
];

export default function Home() {
  return (
    <div>
      <HeroCarousel />
      <CategoryEntry />
      <BrandFocus />
      <EditorPicks />

      <section className="max-w-[1280px] mx-auto px-4 md:px-8 pb-14 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="flex items-center justify-center w-12 h-12 shrink-0 rounded-md bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <TopicSpotlight />

      <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="rounded-lg bg-primary-950 px-6 py-10 md:px-12 md:py-14 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="flex-1">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              关于 {siteConfig.brand} 影视内容站
            </h2>
            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-2xl">
              我们专注于电影与电视剧的剧情介绍、影评资讯与演员资料，尤其关注《姐姐的朋友》相关影视作品，
              希望成为你了解一部作品的第一站。所有内容均为演示数据，用于展示网站结构与阅读体验。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line text-lg" />
              了解我们
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
              搜索作品
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}